
$(document).ready(function () {
    $('.preload').removeClass('preload').addClass('loaded');
    //$('.preload').removeClass('preload').addClass('loaded').addClass('onload');
    //$(window).on('beforeunload', function(){ $('body').removeClass('onload').addClass('beforeunload'); });
    //$(window).on('pagehide', function() { $('body').removeClass('onload').addClass('beforeunload'); });
    //$(window).unload ( function() { $('body').removeClass('onload').addClass('beforeunload'); });
});